import React from "react";
// mui 5
import Avatar from "@mui/material/Avatar";
// custom style
import {
  StyledCardContainer,
  StyledCardHeader,
  StyledCardContent,
} from "./styledComponents";
// custom components
import PokemonTypes from "./PokemonTypes";
import PokemonAbilities from "./PokemonAbilities";
import AddToCartButton from "../AddToCartButton";


function PokemonCardHome({pokemon}) {
  return (
    <StyledCardContainer>
      <StyledCardHeader
        avatar={<Avatar src={pokemon.image} alt={pokemon.name} />}
        title={pokemon.name}
        subheader={`$${pokemon.price}`}
      />

      <StyledCardContent id="styled-card-content">
        <PokemonTypes types={pokemon.types} />
        <PokemonAbilities abilities={pokemon.abilities} />
        <AddToCartButton pokemon={pokemon} />
      </StyledCardContent>

    </StyledCardContainer>
  );
}

export default PokemonCardHome;
